export function formatStatValue(value: number | undefined): string {
  if (value === undefined) return '0'

  // 0 – 99 → keep decimals
  if (value < 100) {
    return value.toString()
  }

  // 100 – 999 → no decimals, truncate
  if (value < 1000) {
    return Math.floor(value).toString()
  }

  // 1,000 – 999,999 → use "k"
  if (value < 1_000_000) {
    const thousands = Math.floor(value / 1000)

    // 1,000 – 99,999 → allow 1 decimal if needed
    if (value < 100_000) {
      const withDecimal = Math.floor(value / 100) / 10
      return withDecimal % 1 === 0 ? `${withDecimal.toFixed(0)}k` : `${withDecimal.toFixed(1)}k`
    }

    // 100,000 – 999,999 → no decimals
    return `${thousands}k`
  }

  const millions = Math.floor(value / 1_000_000)

  // 1,000,000 – 99,999,999 → allow 1 decimal if needed
  if (value < 100_000_000) {
    const withDecimal = Math.floor(value / 100_000) / 10
    return withDecimal % 1 === 0 ? `${withDecimal.toFixed(0)}m` : `${withDecimal.toFixed(1)}m`
  }

  // 100,000,000+ → no decimals
  return `${millions}m`
}
